export default __webpack_public_path__ + "static/media/search_icon.de7d44f0.svg";